import Lottie from "lottie-react";
import Loader from "../../Assets/loader.json";

const Loading = () => {
  
  return(
    <div className="w-full  flex justify-center items-center">
      <Lottie animationData={Loader} loop={true} className="w-56" />
    </div>
  )
}

export default Loading;
